export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5346.b1799f38.jpg";